/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:03:03
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-09 21:31:34
 */
import { default as doHomeModel } from './homeModel';
import { default as doAppModel } from './appModel';

export const sagaHomeModel = doHomeModel.sagas;
export const sagaAppModel = doAppModel.sagas;
